(function () {
  'use strict';
    
  function refreshFragment(selector) {
    fetch(location.href)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var freshDoc = new DOMParser().parseFromString(html, 'text/html');
        var freshEl = freshDoc.querySelector(selector);
        var currentEl = document.querySelector(selector);

        if (freshEl && currentEl) {
          currentEl.innerHTML = freshEl.innerHTML;
        }
      })
      .catch(function (err) {
        console.error('refreshFragment failed for ' + selector, err);
      });
  }
  document.addEventListener('click', function (event) {
    var wishlistButton = event.target.closest('[data-pgrid-wishlist]');
    if (wishlistButton) {
      var pressed = wishlistButton.getAttribute('aria-pressed') === 'true';
      wishlistButton.setAttribute('aria-pressed', String(!pressed));
      wishlistButton.classList.toggle('is-active', !pressed);
      return;
    }

    var addButton = event.target.closest('[data-pgrid-add-to-cart]');
    if (addButton) {
      event.preventDefault();
      addToCart(addButton);
    }

  });

  function addToCart(button) {
    if (button.classList.contains('is-loading') || button.classList.contains('is-added')) {
      return;
    }

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      return;
    }
   
    button.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Could not add to cart');
          });
        }
        return response.json();
      })
      .then(function (response) {
          
        button.classList.remove('is-loading');
        button.classList.add('is-added');

        document.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true })
        );
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
        
        setTimeout(function () {
          button.classList.remove('is-added');
        }, 1800);
        
        refreshFragment(".cart-items-component");
        refreshFragment('.cart-drawer');
      })
      .catch(function () {
        button.classList.remove('is-loading');
        window.location.href = '/cart';
      });
  }
})();